import { useState } from "react";

export const useDialog = (defaultOpen: boolean = false) => {
  const [isDialogOpen, setIsDialogOpen] = useState(defaultOpen);

  const openDialog = () => {
    setIsDialogOpen(true);
  };

  const closeDialog = () => {
    setIsDialogOpen(false);
  };

  const toggleDialog = () => {
    setIsDialogOpen(!isDialogOpen);
  };

  return {
    isDialogOpen,
    openDialog,
    closeDialog,
    toggleDialog,
  };
};
